<div class="custom-container">
    <div class="header">
        <h1>LINEUP</h1>
        <div class="example-spacer"></div>
        <div class="action-buttons">
            <button mat-button class="download-button" (click)="service.Screenshot()">
                <mat-icon>download</mat-icon>
                Descargar
            </button>
            <!--
            <a mat-icon-button class="icon-raised-button" [href]="getTwitterShareUrl()" target="_blank" rel="noopener noreferrer">
                <mat-icon>share</mat-icon>
            </a>
            -->
        </div>
    </div>
    <p>Crea tus plantillas y compártelas en redes sociales mencionando a Atlético Stats.</p>

    <div class="column-container">
        <div class="main-column">
            <lineup-field></lineup-field>
        </div>
        <div class="secondary-column">
            <form class="form-container" [formGroup]="service.getForm('for')">
                <mat-form-field>
                    <mat-label>Nombre del equipo</mat-label>
                    <input matInput formControlName="name" placeholder="Ex. Atleti 25/26">
                </mat-form-field>
            
                <mat-form-field>
                    <mat-label>Elige una formación</mat-label>
                    <mat-select formControlName="formation">
                        <mat-option *ngFor="let formation of formations" [value]="formation">{{formation}}</mat-option>
                    </mat-select>
                </mat-form-field>
            
                <mat-slide-toggle formControlName="badge" matTooltip="Mostrar/Ocultar banderas">
                    <mat-icon>flag</mat-icon>
                </mat-slide-toggle>
                
                <mat-slide-toggle formControlName="sub" matTooltip="Mostrar/Ocultar suplentes">
                    <mat-icon>change_circle</mat-icon>
                </mat-slide-toggle>
            </form>

            <signings-component></signings-component>
        </div>
    </div>
    
    <section>
        <mat-divider></mat-divider>
        <h3>Rumores más probables</h3>
        <div class="carousel-wrapper" #carouselWrapper>
            <p-carousel
            #carousel
            [value]="rumores"
            [numVisible]="numVisible"
            [numScroll]="1"
            [circular]="false"
            orientation="vertical"
            [verticalViewPortHeight]="180*this.numVisible + 'px'"
            class="rumores-carousel"
            >
                <ng-template let-rumor pTemplate="item">
                    <a class="card-wrapper" [routerLink]="'/news/rumores/'+rumor._id">
                        <rumores-card [rumor]="rumor"></rumores-card>
                    </a>
                </ng-template>
            </p-carousel>  
        </div>
    </section>
</div>